import { Money } from 'models';

import useTranslation from 'hooks/useTranslation';

import formatCurrency from 'shared/utils/formatCurrency';

import { Title } from './PurchaseInvoiceTitle.style';

type PurchaseInvoiceTitleProps = {
  sellerOrganizationName: string | null;
  sellerInvoiceNumber: string | null;
  sellerTotalAmount: Money | null;
};

const PurchaseInvoiceTitle = ({
  sellerInvoiceNumber,
  sellerOrganizationName,
  sellerTotalAmount,
}: PurchaseInvoiceTitleProps) => {
  const { t } = useTranslation();

  return (
    <Title variant="h2" align="center">
      {`${sellerOrganizationName} — ${t(
        '#portal.purchaseinvoice.grid.sellerinvoicenumber'
      )} ${sellerInvoiceNumber} — `}
      {formatCurrency(sellerTotalAmount?.Value, sellerTotalAmount?.Code)}
    </Title>
  );
};

export default PurchaseInvoiceTitle;
